import type { ComponentProps } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Field, type FieldProps } from './Field';
import { fieldHintId } from './fieldParts';

type TextFieldProps = ComponentProps<typeof Input> &
  Omit<FieldProps, 'children'> & {
    icon?: LucideIcon;
  };

/** Champ texte libellé, avec icône facultative */
export function TextField({ id, label, hint, required, icon: Icon, error, className, ...inputProps }: TextFieldProps) {
  return (
    <Field id={id} label={label} hint={hint} error={error} required={required}>
      <div className="relative">
        {Icon && <Icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />}
        <Input
          id={id}
          className={`${Icon ? 'pl-9 ' : ''}${className ?? ''}`}
          aria-invalid={!!error}
          aria-required={required || undefined}
          aria-describedby={hint ? fieldHintId(id) : undefined}
          {...inputProps}
        />
      </div>
    </Field>
  );
}
